<template>
    <div class="control has-icons-right secret-input">
        <input
            class="input"
            :type="revealed ? 'text' : 'password'"
            :value="value"
            :placeholder="placeholder"
            :autocomplete="autocomplete"
            @input="$emit('input', $event.target.value)"
        />
        <button
            type="button"
            class="secret-input__toggle"
            :title="revealed ? $t('generic.hide') : $t('generic.show')"
            :aria-label="revealed ? $t('generic.hide') : $t('generic.show')"
            @click="revealed = !revealed"
        >
            <i class="fa" :class="revealed ? 'fa-eye-slash' : 'fa-eye'"></i>
        </button>
    </div>
</template>

<script>
// A masked text field with an eye-icon toggle to reveal the value.
// Behaves as a v-model input (value in, `input` events out). Use for
// API keys, tokens, and other secrets where pre-filling the field
// is desirable but the value should stay masked by default.

export default {
    name: 'secret-input',

    props: {
        value: {type: String, default: ''},
        placeholder: {type: String, default: ''},
        autocomplete: {type: String, default: 'off'},
    },

    data() {
        return {
            revealed: false,
        };
    },
};
</script>

<style lang="scss" scoped>
.secret-input {
    position: relative;

    .input {
        padding-right: 2.5em;
    }

    &__toggle {
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
        width: 2.5em;
        display: flex;
        align-items: center;
        justify-content: center;
        background: transparent;
        border: none;
        cursor: pointer;
        color: #777;

        &:hover {
            color: #333;
        }

        &:focus {
            outline: none;
            color: #333;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/components/secret-input/secret-input.vue